import React from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const KPISetUnqualified = ({ dataProviderName }) => {

    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;

    // Eventualmente, recuperare i filtri del modulo da settings.filterModel
    // const { settings } = useSettingsContext(dataProviderName);

    return (
        <Box className="mtska-chart-wrapper">
            <KPI
                title="Proposals"
                icon="faGauge"
                dataProviderName={'statistics/item/count/opportunities/proposal'}
            />
            <KPI
                title={"Proposals current month (" + formattedDateStartOfMonth + ")"}
                icon="faCalendar"
                dataProviderName={'statistics/currentmonth/count/opportunities/proposal'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateStartOfMonth
                    }]
                }}
            />
            <KPI
                title={"Proposals today"}
                icon="faCalendarStar"
                dataProviderName={'statistics/currentday/count/opportunities/proposal'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateToday
                    }]
                }}
            />
        </Box>
    )
}

export default KPISetUnqualified;